<template>
  <div style="width:100%;height:100%">
    <div class="sky-login">
      <div class="sky-login__header" />
      <div class="sky-login__main">
        <div class="sky-login__form-content">
          <el-form
            v-if="isProdEnv"
            ref="loginForm"
            :model="loginForm"
            :rules="longByPhoneRule"
            class="sky-login__form  login-change"
          >
            <div class="sky-login__form-header">
              <el-form-item class="sky-login__form-item">
                <div>
                  <img class="sky-login__logo" src="@/assets/images/login/wsp_logo.svg" />
                </div>
              </el-form-item>
            </div>
            <div>
              <div style="width:10rem" class="login-change-content" v-if="enablePhoneLogin">
                <span class="chagne-tips" @click="changeLoginType">
                  {{ loginType === 'FEISHU_ERWEIMA' ? '合作伙伴登录在这里' : '原厂登录在这里' }}
                </span>
                <div class="sky-login__change-icon" @click="changeLoginType">
                  <span v-if="loginType === 'FEISHU_ERWEIMA'" class="wsp-icon-dashboard switch-icon"></span>
                  <span v-if="loginType === 'ELEMENT_PHONE'" class="wsp-icon-erweima switch-icon"></span>
                  <span v-if="loginType === 'USER_PASSWROD'" class="wsp-icon-dashboard switch-icon"></span>、
                  <span v-if="loginType === 'CHANNEL'" class="wsp-icon-erweima switch-icon"></span>
                </div>
              </div>
              <div v-if="loginType === 'FEISHU_ERWEIMA'">
                <div id="login_container"></div>
                <div class="font-size-16 wsp-margin-12">原厂请使用飞书扫码登录</div>
              </div>
              <div v-if="loginType === 'CHANNEL'">
                <el-button type="primary" class="sky-login__button" @click.native.prevent="channelLogin">
                  合作伙伴登录
                </el-button>
              </div>

              <div v-if="loginType === 'ELEMENT_PHONE'">
                <el-form-item prop="telephoneNum" class="sky-login__form-item" ellipsis-message>
                  <el-input
                    v-model="loginForm.telephoneNum"
                    placeholder="请输入手机号码"
                    name="telephoneNum"
                    prefix-icon="el-icon-mobile-phone"
                  />
                </el-form-item>
                <el-form-item prop="verifyCode" class="sky-login__form-item">
                  <el-input
                    v-model="loginForm.verifyCode"
                    placeholder="请输入验证码"
                    @blur="registerOrLogin"
                    type="verifyCode"
                    name="verifyCode"
                    prefix-icon="wsp-icon-validate-code"
                  >
                    <div slot="append" v-if="!sendEnd" class="input-append" @click="sendPhoneverifyCode">
                      发送验证码
                    </div>
                    <div slot="append" v-if="sendEnd" class="input-append send-end" id="sendSmsBtn"></div>
                  </el-input>
                </el-form-item>
                <el-form-item>
                  <el-button
                    :loading="loading"
                    type="primary"
                    class="sky-login__button"
                    :disabled="!phoneValidateStatus"
                    @click.native.prevent="registerOrLogin"
                    >登录 / 注册</el-button
                  >
                </el-form-item>
              </div>

              <div v-if="loginType === 'USER_PASSWROD'">
                <el-form-item
                  :rules="userNameRules"
                  prop="userName"
                  class="sky-login__form-item"
                  verify
                  ellipsis-message
                >
                  <el-input
                    v-model="loginForm.userName"
                    :placeholder="$t('login.adminName')"
                    name="userName"
                    prefix-icon="sk-icon-username"
                  />
                </el-form-item>
                <el-form-item :rules="passwordRules" prop="password" class="sky-login__form-item" verify>
                  <el-input
                    v-model="loginForm.password"
                    :placeholder="$t('pwd')"
                    type="password"
                    name="password"
                    prefix-icon="sk-icon-password"
                  />
                </el-form-item>
                <el-form-item>
                  <el-button
                    :loading="loading"
                    type="primary"
                    class="sky-login__button"
                    @click.native.prevent="handleLogin"
                    >{{ $t('login.login') }}</el-button
                  >
                </el-form-item>
              </div>
            </div>
          </el-form>

          <el-form v-else ref="loginForm" :model="loginForm" class="sky-login__form  login-change">
            <div class="sky-login__form-header">
              <el-form-item class="sky-login__form-item">
                <div>
                  <img class="sky-login__logo" src="@/assets/images/login/wsp_logo.svg" />
                </div>
              </el-form-item>
            </div>
            <div class="sky-login__form-body">
              <el-form-item :rules="userNameRules" prop="userName" class="sky-login__form-item" verify ellipsis-message>
                <el-input
                  v-model="loginForm.userName"
                  :placeholder="$t('login.adminName')"
                  name="userName"
                  prefix-icon="sk-icon-username"
                />
              </el-form-item>
              <el-form-item :rules="passwordRules" prop="password" class="sky-login__form-item" verify>
                <el-input
                  v-model="loginForm.password"
                  :placeholder="$t('pwd')"
                  type="password"
                  name="password"
                  prefix-icon="sk-icon-password"
                />
              </el-form-item>
              <el-form-item>
                <el-button
                  :loading="loading"
                  type="primary"
                  class="sky-login__button"
                  @click.native.prevent="handleLogin"
                  >{{ $t('login.login') }}</el-button
                >
              </el-form-item>
            </div>
          </el-form>
        </div>
      </div>

      <div class="sky-login__bottom">
        <div class="sky-login__about">
          <div class="sky-login__about-left">
            <a target="_blank" class="sky-login__about-txt" href="https://ocs.ruijie.com.cn/?p=rcd">{{
              $t('login.online')
            }}</a>
            <span class="sky-login__about-txt">{{ $t('login.hotline') }}</span>
            <span class="sky-login__about-txt">{{ $t('login.rj') }}©2024</span>
            <a target="_blank" class="sky-login__about-txt" :href="trainPlatformUrl">{{ $t('login.feitian') }} </a>
          </div>
          <div class="sky-login__about-right" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Form, Input, Button, Tooltip } from 'element-ui'
import { on, off } from 'sk-ui/lib/utils/util'

import { sendVerifyCodeOnPhone, verifyPhoneCode } from '@/api/setting'
import GlobalConst from '@/constant/globalConst'

var second = 60

export default {
  name: 'Login',
  components: {
    [Form.name]: Form,
    [Input.name]: Input,
    [Button.name]: Button,
    [Tooltip.name]: Tooltip
  },
  data() {
    var checkPhone = (rule, value, callback) => {
      const reg = /^1[3-9]\d{9}$/
      if (value === '') {
        callback(new Error('手机号码不能为空'))
      } else if (!reg.test(value)) {
        callback(new Error('请输入正确的手机号码'))
      } else {
        callback()
      }
    }

    var checkVliateCode = (rule, value, callback) => {
      const reg = /^\d{6}$/
      if (value === '') {
        callback(new Error('验证码不能为空'))
      } else if (!reg.test(value)) {
        callback(new Error('请输入6位验证码'))
      } else {
        callback()
      }
    }

    return {
      isProdEnv: window.location.host.includes('.ruijie.com.cn'),
      loginType: 'CHANNEL',
      loginForm: {
        userName: '',
        password: '',
        telephoneNum: null,
        verifyCode: null
      },
      loading: false,
      sendEnd: false,
      countdown: null,
      enablePhoneLogin: true,
      phoneValidateStatus: false,
      longByPhoneRule: {
        telephoneNum: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { validator: checkPhone, trigger: ['blur'] }
        ],
        verifyCode: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { validator: checkVliateCode, trigger: ['blur'] }
        ]
      },
      userNameRules: [{ notEmpty: this.$t('login.adminName') }, 'textName', 'textShort'],
      passwordRules: [{ notEmpty: this.$t('pwd') }],
      trainPlatformUrl: GlobalConst.TRAIN_PLATFORM_URL
    }
  },
  mounted() {
    this.$store.dispatch('CloseAllNotification')
    if (this.isProdEnv && this.loginType === 'FEISHU_ERWEIMA') {
      this.relaodFeiShuErWeima()
    }

    on(document, 'keydown', this.handleKeydown)
  },
  beforeDestroy() {
    off(document, 'keydown', this.handleKeydown)
  },
  methods: {
    relaodFeiShuErWeima() {
      var go_to = 'https://wsp.ruijie.com.cn/feishu/loginSuccess'
      var goto =
        'https://passport.feishu.cn/suite/passport/oauth/authorize?client_id=cli_a56b3651d938d013&redirect_uri=' +
        go_to +
        '&response_type=code&state=STATE'
      // eslint-disable-next-line no-undef
      var QRLoginObj = QRLogin({
        id: 'login_container',
        goto: goto,
        width: '260',
        height: '260' //可选的，二维码html标签的style属性
      })

      this.calculateQRCodeSize()

      var handleMessage = function(event) {
        // 使用 matchOrigin 和 matchData 方法来判断 message 和来自的页面 url 是否合法
        if (QRLoginObj.matchOrigin(event.origin) && QRLoginObj.matchData(event.data)) {
          var loginTmpCode = event.data.tmp_code

          // 在授权页面地址上拼接上参数 tmp_code，并跳转
          window.location.href = `${goto}&tmp_code=${loginTmpCode}`
        }
      }
      if (typeof window.addEventListener != 'undefined') {
        window.addEventListener('message', handleMessage, false)
      } else if (typeof window.attachEvent != 'undefined') {
        window.attachEvent('onmessage', handleMessage)
      }
    },
    changeLoginType() {
      this.loginType = this.loginType === 'FEISHU_ERWEIMA' ? 'CHANNEL' : 'FEISHU_ERWEIMA'
      if (this.loginType === 'FEISHU_ERWEIMA') {
        this.$nextTick(() => {
          this.relaodFeiShuErWeima()
        })
      }
    },
    channelLogin() {
      const channelUrl = 'https://sid.ruijie.com.cn/channel/login?service=https://wsp.ruijie.com.cn'
      window.location = channelUrl
    },
    startCountdown() {
      var btn = document.getElementById('sendSmsBtn')
      if (second > 0) {
        btn.innerHTML = second + '秒后重新获取'
        second--
        setTimeout(this.startCountdown, 1000) // 每秒调用一次
      } else {
        btn.innerHTML = ''
        this.sendEnd = false
        second = 60 // 重置倒计时时间
      }
    },
    registerOrLogin() {
      this.$refs.loginForm.validateField('verifyCode', valid => {
        if (valid) {
          return
        }
        if (!valid) {
          verifyPhoneCode(this.loginForm).then(res => {
            this.$store.getters.phoneValidateCode = this.loginForm
            if (!res.data.content.hasUser) {
              this.$router.push({ path: '/register' })
            } else {
              this.$store
                .dispatch('LoginByPhone', this.loginForm)
                .then(() => {
                  this.$router.push({ path: '/userInfo' })
                })
                .catch(e => {
                  this.loading = false
                  throw e
                })
            }
          })
        }
      })
    },
    sendPhoneverifyCode() {
      //点击发送验证码
      this.$refs.loginForm.validateField('telephoneNum', valid => {
        if (valid) {
          return
        }
        if (!valid) {
          second = 60 // 重置倒计时时间
          sendVerifyCodeOnPhone({ telephoneNum: this.loginForm.telephoneNum }).then(res => {
            this.sendEnd = true
            this.phoneValidateStatus = true
            this.$nextTick(() => {
              this.startCountdown()
            })
          })
        }
      })
    },
    calculateQRCodeSize() {
      // 获取屏幕宽度和高度
      const screenWidth = window.innerWidth
      const screenHeight = window.innerHeight

      // 计算屏幕的像素密度
      const pixelDensity = Math.sqrt(screenWidth * screenWidth + screenHeight * screenHeight) / Math.sqrt(1920 * 1080)

      var sc = pixelDensity / 1.5

      // 根据屏幕像素密度调整二维码尺寸
      var iframs = document.getElementsByTagName('iframe')

      iframs[0].style.transform = 'scale(' + sc + ')'
      iframs[0].style.transformOrigin = 'top left'
    },
    handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true
          this.$store
            .dispatch('LoginByUsername', this.loginForm)
            .then(() => {
              this.$router.push({ path: '/dashboard' })
            })
            .catch(e => {
              this.loading = false
              throw e
            })
        }
      })
    },
    handleKeydown(e) {
      const keyCode = e.keyCode
      if (keyCode === 13 && !this.loading) {
        this.handleLogin()
      }
    }
  }
}
</script>

<style>
#login_container iframe {
  border: 0 !important;
  object-fit: contain;
}
#login_container {
  width: 275px;
  height: 275px;
  margin: auto;
}

.login-change-content .chagne-tips {
  right: 64px;
  top: 6px;
  position: absolute;
  font-size: 14px;
  cursor: pointer;
  border: 1px solid #dceefe;
  padding: 3px;
  background-color: #dceefe;
  border-radius: 7px;
  font-size: 12px;
}

.login-change-content .chagne-tips::after {
  content: '';
  display: block;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  border-left: 6px solid #dceefe;
  position: absolute;
  right: -6px;
  top: 3px;
  z-index: 2;
}
</style>
